import { NextButton } from './nextButton';

export default NextButton;